module.exports = __webpack_public_path__ + "static/media/206-Telefonat_ID_46.8a6ddd0a.mp3";